import { tooltipPositionType } from "../../../types/common";
import tooltipStyles from "../../../styles/tooltip.module.css";
import { useClickOutside } from "../../../hooks/useClickOutside";
import { useTooltipPosition } from "../../../hooks/useTooltipPosition";
import { useDropdownPosition } from "../../../hooks/useDropdownPosition";
import { getTooltipClasses } from "../../../service/tooltipService";
import { useEffect, useState } from "react";

const ClickAndHoverableTooltip = ({
  hoverElement,
  position,
  hoveredChildclasses,
  disableTopStyles,
  tooltipModalWidth,
  hoverElementWidth,
  hoveredChild,
  clickedChild,
  clickedChildclasses
}: {
  hoverElement: React.ReactNode;
  position?: tooltipPositionType;
  hoveredChildclasses?: string;
  clickedChildclasses?: string;
  disableTopStyles?: boolean;
  tooltipModalWidth?: number;
  hoverElementWidth?: string;
  hoveredChild?: React.ReactNode;
  clickedChild?: React.ReactNode;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const {
    currentPosition,
    tooltipRef,
    triggerRef: hoverElementRef
  } = useTooltipPosition(isHovered, position);

  const { isPositionedTop: isTooltipPositionedTop, dropdownRef: optionsRef } =
    useDropdownPosition(isClicked);

  useClickOutside(hoverElementRef, () => setIsClicked(false));

  // hide the hovered tooltip when the clicked tooltip is visible
  useEffect(() => {
    if (isClicked && isHovered) {
      setIsHovered(false);
    }
  }, [isHovered, isClicked]);

  const hoveredTooltipClasses = getTooltipClasses(
    tooltipStyles.tooltipOnHover,
    disableTopStyles && currentPosition === "top"
      ? tooltipStyles.tooltipOnHoverOnlyTop
      : tooltipStyles[currentPosition],
    disableTopStyles,
    hoveredChildclasses
  );

  const clickedTooltipClasses = getTooltipClasses(
    tooltipStyles.tooltipOnClick,
    isTooltipPositionedTop ? tooltipStyles.tooltipTopPosition : "",
    false,
    clickedChildclasses
  );

  return (
    <div
      className={tooltipStyles.tooltipOnHoverWrapper}
      ref={hoverElementRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        flexBasis: hoverElementWidth ? `${hoverElementWidth}px` : "auto"
      }}
      onClick={() => setIsClicked((prev) => !prev)}
    >
      {hoverElement}

      {/* hovered tooltip */}
      {isHovered && (
        <div
          ref={tooltipRef}
          style={{ width: `${tooltipModalWidth}px` }}
          className={hoveredTooltipClasses}
          onClick={(e) => e.stopPropagation()}
        >
          {hoveredChild}
        </div>
      )}

      {/* clicked tooltip */}
      {isClicked && (
        <div ref={optionsRef} className={clickedTooltipClasses}>
          {clickedChild}
        </div>
      )}
    </div>
  );
};

export default ClickAndHoverableTooltip;
